import axios from "axios";
import { baseURL } from "./config";

const HttpClient: any = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});
export default HttpClient;
